import React from "react";
import { func } from "prop-types";

import { locations } from "../../propTypes";
import * as S from "./styled";
import { areasLabel } from "./utils";

const LocationFilterTrigger = React.forwardRef(
  ({ onClick, selectedAreas, ...props }, ref) => (
    <S.Trigger ref={ref} onClick={onClick} {...props}>
      <S.MapPinIcon />
      {areasLabel(selectedAreas)}
    </S.Trigger>
  )
);

LocationFilterTrigger.propTypes = {
  selectedAreas: locations,
  onClick: func
};

LocationFilterTrigger.defaultProps = {
  onClick: () => {},
  selectedAreas: []
};

export default LocationFilterTrigger;
